import { render, staticRenderFns } from "./SelectFacilityVBI.vue?vue&type=template&id=5a080136&scoped=true&"
import script from "./SelectFacilityVBI.vue?vue&type=script&lang=js&"
export * from "./SelectFacilityVBI.vue?vue&type=script&lang=js&"
import style0 from "./SelectFacilityVBI.vue?vue&type=style&index=0&id=5a080136&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a080136",
  null
  
)

export default component.exports